// Runs `task` once the page has loaded and the main thread is idle, for work
// that must not sit on the startup path (Sentry Replay's DOM recorder, for
// one). `timeout` bounds the idle wait so the task still runs on a page that
// never goes idle. Returns a cancel function.
export function runWhenIdle(task: () => void, timeout = 5000): () => void {
    let cancelled = false;
    let idleId: number | undefined;
    let timerId: ReturnType<typeof setTimeout> | undefined;
    const schedule = () => {
        if (cancelled) return;
        if (typeof requestIdleCallback === 'function') {
            idleId = requestIdleCallback(() => { if (!cancelled) task(); }, {timeout});
        } else {
            timerId = setTimeout(() => { if (!cancelled) task(); }, timeout);
        }
    };
    if (document.readyState === 'complete') {
        schedule();
    } else {
        window.addEventListener('load', schedule, {once: true});
    }
    return () => {
        cancelled = true;
        window.removeEventListener('load', schedule);
        if (idleId !== undefined && typeof cancelIdleCallback === 'function') cancelIdleCallback(idleId);
        if (timerId !== undefined) clearTimeout(timerId);
    };
}
